var map = {
	"./international.de-CH.json": 1648,
	"./international.de-DE.json": 1649,
	"./international.en-CA.json": 1650,
	"./international.en-GB.json": 1651,
	"./international.en-IN.json": 1652,
	"./international.en-ME.json": 1653,
	"./international.en-US.json": 1654,
	"./international.es-EM.json": 1655,
	"./international.es-ES.json": 1656,
	"./international.fr-BE.json": 1657,
	"./international.fr-CA.json": 1658,
	"./international.fr-CH.json": 1659,
	"./international.nl-BE.json": 1660,
	"./international.nl-NL.json": 1661,
	"./international.pl-PL.json": 1662,
	"./international.pt-BR.json": 1663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1647;